<div class="button-container" (click)="clicked()">
  <ng-content></ng-content>
</div>
